import { STATUSES, PAY_STATUS } from "../lib/api";

export function StatusBadge({ status, "data-testid": tid }) {
  const s = STATUSES[status] || { label: status, cls: "bg-slate-100 text-slate-600 border-slate-200" };
  return (
    <span data-testid={tid} className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${s.cls}`}>
      {s.label}
    </span>
  );
}

export function PayBadge({ status, "data-testid": tid }) {
  const s = PAY_STATUS[status] || { label: status, cls: "bg-slate-100 text-slate-600 border-slate-200" };
  return (
    <span data-testid={tid} className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${s.cls}`}>
      {s.label}
    </span>
  );
}
